export default __webpack_public_path__ + "static/media/qs.3006546f.png";